import React from "react";

export default function LoadingIndicatorText() {
  return (
    <span className="loading">
      <i className="fa fa-spinner fa-spin"></i>
      Loading&hellip;
    </span>
  );
}
